PJQ.views.budget.ProjectBudgetDataTable = PJQ.views.dataTables.DataTable.extend({
    childRowToggle: function (sender, rowOverride) {
        let $target = rowOverride ? $(rowOverride.selector.rows).find(this.options.toggleRowClass) : $(sender.currentTarget),
            id = $target.data('id'),
            tr = $target.closest('tr'),
            row = this.getRow(tr);
        if (row.child.isShown() && rowOverride == null) {
            // This row is already open - close it
            this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                return childDt.options.parentId !== id;
            }, this));
            row.child.hide();
            tr.removeClass('shown');
            $target.removeClass('fa-minus-circle').addClass('fa-plus-circle');
        } else {
            $target.removeClass('fa-plus-circle').addClass('fa-minus-circle');

            this.renderChildRow(row, id);
        }
    },
    toggleChildRow: function (row) {
        let tr = $(row.node()),
            id = row.data()[this.options.rowId],
            $icon = tr.find(this.options.toggleRowClass);
        if (row.child.isShown()) {
            // This row is already open - close it
            this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                return childDt.options.parentId !== id;
            }, this));
            row.child.hide();
            tr.removeClass('shown');
            $icon.removeClass('fa-minus-circle').addClass('fa-plus-circle');
        } else {
            $icon.removeClass('fa-plus-circle').addClass('fa-minus-circle');

            this.renderChildRow(row, id);
        }
    },
    renderChildRow: function (row, parentId) {
        //row.child.hide();
        let childClass = 'subgrid-' + parentId.toString(),
            $childTable = $('<div data-id="' + parentId + '" />', {
                class: childClass + ' p-2'
            });
        row.child($childTable).show();

        let childData = this.getRowChildData(row);
        if (childData != null) {
            let fnRender = _.bind(function () {
                let childTable = this.getRowChildTable({
                    el: $childTable,
                    data: PJQ.helpers.objectHelpers.isBackboneCollection(childData) ? childData.models : childData,
                    isHideSearch: true,
                    parentId: parentId,
                    parentData: row.data()
                });
                this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                    return childDt.options.parentId !== parentId;
                }, this));
                this.options.childDataTables.push(childTable);
            }, this);

            if (PJQ.helpers.objectHelpers.isBackboneModel(childData)) {
                childData.fetch({
                    success: _.bind(function () {
                        // loader.remove();
                        fnRender();
                    }, this)
                });
            } else {
                fnRender();
            }
        }
    },
    getRowChildTable: function (opts) {
        if (typeof this.options.getRowChildTable === 'function') {
            return this.options.getRowChildTable(opts);
        }
        return null;
    },
    getRowChildData: function (row) {
        if (typeof this.options.getRowChildData === 'function') {
            return this.options.getRowChildData(row);
        }
        return {};
    },
});

PJQ.views.budget.ProjectBudget = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'project-budget'),
        canEdit: true,
        isAdmin: true,
        groupByCookie: 'budget_group_by',
        groupBy: ['division', 'costcode']
    },
    events: {
        // 'click .expand-item': 'expandTableClicked',
        'click .btn-push-erp': 'pushERP',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-pull-erp': 'pullERP',
        'click .btn-link-erp': 'linkERP',
        'click .btn-add-line-items': 'addLineItems',
        'click .btn-edit-budget': 'editLineItemBudgetClicked',
        'click .btn-edit-forecast': 'editLineItemForecastClicked',
        'click .btn-view-modifications': 'viewLineItemModificationsClicked',
        'click .btn-view-prime-contracts': 'viewLineItemPrimeContractsClicked',
        'click .btn-view-commitments': 'viewLineItemCommitmentsClicked',
        'click .btn-view-cco': 'viewLineItemCommitmentChangeOrdersClicked',
        'click .btn-view-pcco': 'viewLineItemPrimeContractChangeOrdersClicked',
        'click .btn-view-receivable-invoices': 'viewLineItemReceivableInvoicesClicked',
        'click .btn-view-payable-invoices': 'viewLineItemPayableInvoicesClicked',
        'click .btn-view-direct-costs': 'viewLineItemDirectCostsClicked',
        'click .btn-add-modification': 'addBudgetModifications',
        'click .btn-lock-budget': 'lockBudget',
        'click .btn-unlock-budget': 'unlockBudget',
        'keyup .budget-search': 'searchBudget',
        'click .btn-export': 'exportBudget',
        'click .expand-all-items': 'expandAllClicked'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.options.project = this.options.project != null ? this.options.project : PJQ.app.session.project;

        this.options.canEdit = PJQ.app.session.project.hasPermission('budget.canEdit');
        this.options.isAdmin = PJQ.app.session.project.hasPermission('budget.isAdmin');

        let gbCookie = PJQ.helpers.cookieHelpers.getCookie(this.options.groupByCookie);
        if (gbCookie != null) {
            this.options.groupBy = _.size(gbCookie) > 0 ? gbCookie.split(',') : [];
        }

        this.expandedItems = [-1];

        this.subJobs = await this.options.project.fetchSubJobs();

        this.costCodes = await this.options.project.fetchCostCodes();
        this.options.hasDivisions = this.costCodes.hasDivisions();

        this.costTypes = await this.options.project.fetchCostTypes();

        this.budget = await this.options.project.fetchBudget(null, {
            force: true
        });
        this.currentBudget = this.budget;

        this.snapshots = await this.options.project.fetchBudgetSnapshots();

        this.budgetViews = await this.options.project.fetchBudgetViews();
        this.setActiveView();

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        await this.options.project.fetchERPObject();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        this.childDataTables = [];
    },
    renderData: function () {
        return {
            model: this.model,
            canUnlock: this.canUnlock,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderERP();

        this.options.groupBy = _.without(this.options.groupBy, 'subjob');
        if (_.size(this.subJobs.models) > 0) {
            this.options.groupBy = _.union(['subjob'], this.options.groupBy);
        }

        if (!this.options.hasDivisions && this.options.groupBy.indexOf('division') !== -1) {
            this.options.groupBy = _.without(this.options.groupBy, 'division');
        }

        this.fetchBudgetForActiveView(_.bind(function () {
            let data = this.getDataForLevel(0);
            this.renderDatatable(this.$(".budget-table"), data);
        }, this));
    },
    renderERP: function () {
        if (!this.options.project.isERPSynced() || this.budget.get('snapshotOfId') != null) {
            return;
        }

        let hasUnsynced = false;
        _.each(this.budget.lineItems.models, function (lineItem) {
            let status = lineItem.erpSyncStatus();
            if (status !== PJQ.constants.integrations.erp.syncStatuses.APPROVED && status !== PJQ.constants.integrations.erp.syncStatuses.SYNCED) {
                hasUnsynced = true;
            }
        });

        let $erp = this.$('.erp-sync'),
            budgetStatus = this.budget.erpSyncStatus(),
            reviewing = PJQ.constants.integrations.erp.syncStatuses.REVIEWING,
            synced = PJQ.constants.integrations.erp.syncStatuses.SYNCED,
            approved = PJQ.constants.integrations.erp.syncStatuses.APPROVED,
            status;
        if (budgetStatus === reviewing) {
            status = reviewing;
        } else if (hasUnsynced && budgetStatus === synced) {
            status = PJQ.constants.integrations.erp.syncStatuses.STALE;
        } else {
            status = budgetStatus;
        }

        if (budgetStatus == null) {
            budgetStatus = PJQ.constants.integrations.erp.syncStatuses.PENDING;
        }

        this.erpButtons = PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_BUDGET),
            canPush: hasUnsynced && budgetStatus !== reviewing,
            disablePushReason: !hasUnsynced ? 'All budget updates have been pushed to ERP' : '',
            pullSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_BUDGET),
            canPull: budgetStatus !== approved,
            status: status
        });

        let badge = PJQ.helpers.erp.getERPBadge(status, this.budget.get('externalObject'));
        if (_.size(badge) > 0) {
            this.$('.erp-badge').html('<span class="ml-2">' + badge + '</span>');
        }
    },
    setActiveView: function (viewId) {
        this.view = _.find(this.budgetViews.models, function (budgetView) {
            if (viewId == null) {
                return budgetView.get('isDefault');
            }
            return budgetView.id === viewId;
        });

        if (this.view == null) {
            // we didn't find a default view or a view matching the argument viewId
            // here we use the standard budget view
            this.view = _.find(this.budgetViews.models, function (budgetView) {
                return budgetView.get('companyId') === -1;
            });
        }
        this.budgetView = null;
    },
    fetchBudgetForActiveView: function (callback) {
        if (this.budgetView == null) {
            this.budget.fetchForView(this.view.id, _.bind(function (res) {
                this.budgetView = res;
                callback(this.budgetView);
            }, this));
        } else {
            if (typeof callback === 'function') {
                callback(this.budgetView);
            }
        }
    },
    getDataForLevel: function (level, parentData = null) {
        let groupByLevel = _.size(this.options.groupBy) >= level + 1 ? this.options.groupBy[level] : null;
        if (groupByLevel == null) {
            let groupByCostCode = this.options.groupBy.indexOf('costcode') !== -1;
            return _.map(_.filter(this.budgetView.lineItems, function (lineItem) {
                return parentData == null || parentData.lineItemIds.indexOf(lineItem.id) !== -1;
            }), function (lineItem) {
                let costCode = this.costCodes.get(lineItem.costCodeId),
                    costType = this.costTypes.get(lineItem.costTypeId),
                    budgetCode;
                if (groupByCostCode) {
                    budgetCode = costType.get('name');
                } else {
                    budgetCode = '<div>' + costCode.getDisplayName() + '</div><div class="fs-13 text-muted">' + costType.get('name') + '</div>'
                }
                return _.defaults({
                    costCode: costCode,
                    costType: costType,
                    budgetCode: budgetCode
                }, lineItem);
            }, this);
        } else {
            let parents = {};
            _.each(this.budgetView.lineItems, function (lineItem) {
                if (parentData != null && parentData.lineItemIds.indexOf(lineItem.id) === -1) {
                    return;
                }

                let parent;
                if (groupByLevel === 'subjob') {
                    let subJob = this.subJobs.get(lineItem.subJobId),
                        subJobId = subJob ? subJob.id : -1;
                    if (parents[subJobId] != null) {
                        parents[subJobId].lineItemIds.push(lineItem.id);
                    } else {
                        parents[subJobId] = ({
                            id: PJQ.helpers.guid(),
                            budgetCode: subJob ? subJob.get('name') : this.options.project.get('projectName'),
                            lineItemIds: [lineItem.id],
                            columnData: []
                        });
                    }

                    parent = parents[subJobId];
                } else if (groupByLevel === 'division') {
                    let costCode = this.costCodes.get(lineItem.costCodeId);
                    if (parents[costCode.get('division')] != null) {
                        parents[costCode.get('division')].lineItemIds.push(lineItem.id);
                    } else {
                        parents[costCode.get('division')] = ({
                            id: PJQ.helpers.guid(),
                            budgetCode: costCode.get('division'),
                            lineItemIds: [lineItem.id],
                            columnData: []
                        });
                    }

                    parent = parents[costCode.get('division')];
                } else if (groupByLevel === 'costcode') {
                    let costCode = this.costCodes.get(lineItem.costCodeId);
                    if (parents[costCode.id] != null) {
                        parents[costCode.id].lineItemIds.push(lineItem.id);
                    } else {
                        parents[costCode.id] = ({
                            id: PJQ.helpers.guid(),
                            budgetCode: costCode.getDisplayName(),
                            costCode: costCode,
                            costCodeId: lineItem.costCodeId,
                            lineItemIds: [lineItem.id],
                            columnData: []
                        });
                    }

                    parent = parents[costCode.id];
                }

                if (parent != null) {
                    _.each(this.budgetView.columns, function (column, index) {
                        let val;
                        if (column.format === 'money' || column.format === 'decimal' || column.format === 'integer' || column.format === 'percent' || column.format === 'time') {
                            if (_.size(parent.columnData) >= index + 1) {
                                val = parent.columnData[index];
                            } else {
                                val = 0;
                            }

                            let liVal = lineItem.columnData[index] ?? 0;
                            if (column.format === 'money') {
                                val += parseInt(PJQ.helpers.formatHelpers.numbersOnly(liVal, false, true));
                            } else if (column.source === 'TimeCardValues') {
                                if (!Array.isArray(val)) {
                                    val = [];
                                }

                                val.push(liVal);
                            } else {
                                val += liVal;
                            }
                        } else {
                            val = '';
                        }
                        parent.columnData[index] = val;
                    });
                }
            }, this);

            _.each(parents, function (parent) {
                _.each(this.budgetView.columns, function (column, index) {
                    if (column.format === 'money') {
                        parent.columnData[index] = PJQ.helpers.formatHelpers.formatCurrency(parent.columnData[index]);
                    } else if (column.format === 'integer' || column.format === 'decimal' || column.format === 'percent' || column.format === 'time') {
                        parent.columnData[index] = parent.columnData[index];
                    }
                });
            }, this);

            let data = [];
            _.each(parents, function (lineItem) {
                data.push(lineItem);
            })

            return data;
        }
    },
    renderDatatable: function ($element, data, level = 0, parentTable = null) {
        let contextMenuActions = [],
            isLastLevel = level === _.size(this.options.groupBy),
            groupBy = isLastLevel ? null : this.options.groupBy[level];
        if (groupBy === null) {
            contextMenuActions = [
                {
                    name: 'Add to Budget',
                    isShown: _.bind(function (row) {
                        let lineItem = this.budget.lineItems.get(row.data().id);
                        return lineItem.get('isUnBudgeted');
                    }, this),
                    onClick: _.bind(function (row) {
                        let lineItem = this.budget.lineItems.get(row.data().id);
                        this.addLineItemToBudget(lineItem);
                    }, this)
                },
                {
                    name: 'Edit Original Budget',
                    isShown: _.bind(function (row) {
                        return !this.budget.get('isLocked') && this.options.canEdit;
                    }, this),
                    onClick: _.bind(function (row) {
                        this.editLineItemBudget(row.data().id);
                    }, this)
                },
                {
                    name: 'View Modifications',
                    isShown: _.bind(function (row) {
                        return this.budget.get('isLocked');
                    }, this),
                    onClick: _.bind(function (row) {
                        let lineItem = this.budget.lineItems.get(row.data().id);
                        this.viewLineItemModifications(lineItem);
                    }, this)
                },
                {
                    name: 'Edit Forecast',
                    // isShown: _.bind(function (row) {
                    // 	return this.budget.get('isLocked');
                    // }, this),
                    onClick: _.bind(function (row) {
                        this.editLineItemForecast(row.data().id)
                    }, this),
                    isShown: _.bind(function (row) {
                        return !this.budget.get('isLocked') && this.options.canEdit;
                    }, this)

                },
                {
                    name: 'Delete',
                    isShown: _.bind(function (row) {
                        return !this.budget.get('isLocked') && this.options.isAdmin;
                    }, this),
                    onClick: _.bind(function (row) {
                        let lineItem = this.budget.lineItems.get(row.data().id);
                        this.deleteLineItem(lineItem);
                    }, this)
                }
            ];
        }

        let dt = new PJQ.views.budget.ProjectBudgetDataTable({
            rowId: "id",
            el: $element,
            data: data,
            isHideSearch: level > 0,
            paging: false,
            order: [1, 'asc'],
            extraClasses: !isLastLevel ? 'rows-muted' : '',
            language: {
                zeroRecords: '',
                emptyTable: ''
            },
            rowCallback: function (row, data) {
                if (data.isUnBudgeted) {
                    $(row).attr('style', 'background-color: #ffefbe !important');
                }
            },
            drawCallback: _.bind(function (settings) {
                if (parentTable != null) {
                    // If you open up a bunch of child rows, an ugly border starts to form between them all growing with every new child row opened.
                    // need to collapse the group-start every time to prevent this
                    this.$('.group-start').attr('style', 'visibility: collapse;');
                    // Remove child tables header
                    $element.find('thead').attr('style', 'visibility: collapse;');
                }

                if (level === 0) {
                    this.snapshotSelect = new PJQ.inputs.Selectpicker({
                        el: this.$('.select-snapshot'),
                        defaultValue: this.budget === this.currentBudget ? -1 : this.budget.get('id'),
                        isIntChoices: true,
                        onChange: _.bind(function (value) {
                            if (value === -2) {
                                this.createSnapshot();
                                this.snapshotSelect.setValue(-1)
                            } else if (value === -1) {
                                this.budget = this.currentBudget;
                                this.budgetView = null;
                                this.render();
                            } else {
                                this.budget = new PJQ.models.budget.Budget({id: value});
                                this.budget.fetch({
                                    success: _.bind(function () {
                                        this.budgetView = null;
                                        this.render();
                                    }, this)
                                })
                            }
                        }, this)
                    });

                    this.groupBySelector = new PJQ.inputs.Selectpicker({
                        el: this.$('.budget-group-by'),
                        hideDisabled: false,
                        isMultiple: true,
                        noneSelectedText: 'No Grouping',
                        defaultValue: this.options.groupBy,
                        onChange: _.bind(function (value) {
                            this.setGroupBy(value);
                        }, this)
                    });

                    this.viewSelector = new PJQ.inputs.Selectpicker({
                        el: this.$('.budget-view-select'),
                        defaultValue: this.view.id,
                        isIntChoices: true,
                        onChange: _.bind(function (value) {
                            if (value === -1) {
                                this.viewSelector.setValue(this.view.id);
                                this.manageViews();
                            } else {
                                this.setActiveView(value);
                                this.budgetView = null;
                                this.render();
                            }
                        }, this)
                    });
                }
            }, this),
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'data-table-header-budget')
            },
            headerData: _.bind(function () {
                let erpStatus = this.budget.erpSyncStatus(),
                    erpReviewing = erpStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED || erpStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING;
                return {
                    subJobs: this.subJobs,
                    hasDivisions: this.options.hasDivisions,
                    isLocked: this.budget.get('isLocked'),
                    erpReviewing: erpReviewing,
                    views: this.budgetViews,
                    snapshots: this.snapshots,
                    isAdmin: this.options.isAdmin,
                    canEdit: this.options.canEdit,
                    isSnapshot: this.budget.get('snapshotOfId') != null,
                    erpIntegration: this.erpIntegration,
                    project: PJQ.app.session.project
                };
            }, this),
            hasFooter: level === 0,
            afterDataTableRender: _.bind(function () {
                if (_.size(this.expandedItems) > 0) {
                    this.expandChildTables(dt, level + 1);
                }

                if (level === 0) {
                    this.renderTableFooter();
                }
            }, this),
            afterHeaderRender: () => {
                this.renderERP();
            },
            contextMenuOptions: {
                actions: contextMenuActions
            },
            columns: this.getColumns(level)
        });

        if (parentTable != null) {
            parentTable.options.childDataTables.push(dt);
        } else {
            this.dataTable = dt;
        }

        if (_.size(this.expandedItems) > 0) {
            this.expandChildTables(dt, level + 1);
        }

        this.$el.on('click', '.expand-item', _.bind(function (e) {
            let $target = $(e.currentTarget),
                tr = $target.closest('tr'),
                row = dt.getRow(tr);
            if (row.data()) {
                this.renderChildTable(row, dt, level + 1);
            }
        }, this));
    },
    setGroupBy: function (value) {
        this.options.groupBy = value;
        PJQ.helpers.cookieHelpers.setCookie(this.options.groupByCookie, _.size(value) > 0 ? value.join(',') : '');

        if (this.dataTable != null) {
            this.render();
        }
    },
    renderTableFooter: function () {
        let $footer = this.$('tfoot').first(),
            $totalTextCol = $footer.find('th').eq(1);
        $totalTextCol.html("<span class='font-weight-bold'>Grand Total</span>");
        _.each(this.budgetView.columns, function (column, index) {
            if (column.format == null) {
                return;
            }

            let format = column.format.toLowerCase();
            if (format === 'money' || format === 'decimal' || format === 'integer' || format === 'percent' || format === 'time') {
                let total = 0;
                _.each(this.budgetView.lineItems, function (lineItem) {
                    if (lineItem.columnData != null) {
                        if (column.source === 'TimeCardValues') {
                            let minutes = PJQ.helpers.dateHelpers.getMinutesFromHoursDecimal(lineItem.columnData[index] / 100);
                            total += minutes;
                        } else {
                            let cVal = lineItem.columnData[index];
                            if (typeof cVal === 'string') {
                                cVal = PJQ.helpers.formatHelpers.numbersOnly(cVal, true, true);
                            }
                            total += parseFloat(cVal);
                        }
                    }
                });

                // we add a +2 offset because there is always an actions and "Description" column on the left
                let $footerCol = $footer.find('th').eq(index + 2);
                if (format === 'money') {
                    $footerCol.text(PJQ.helpers.formatHelpers.formatCurrency(total));
                } else if (format === 'integer') {
                    $footerCol.text(total);
                } else if (format === 'decimal') {
                    if (column.source === 'TimeCardValues') {
                        $footerCol.text(PJQ.helpers.timecards.getFormattedTime(total));
                    } else {
                        $footerCol.text((total).toFixed(2));
                    }
                } else if (format === 'time') {
                    $footerCol.text(PJQ.helpers.timecards.getFormattedTime(total));
                } else if (format === 'percent') {
                    $footerCol.text((total / 100).toFixed(2) + '%');
                }
            }
        }, this);
    },
    lockBudget: function () {
        this.budget.updateLocked(true, _.bind(function (success) {
            if (success) {
                this.render();
            }
        }, this));
    },
    linkERP: function () {
        new PJQ.integrations.models.LinkERPProjectModal({
            project: PJQ.app.session.project,
            onSave: _.bind(function (erpProject) {
                if (erpProject != null && _.size(erpProject.id) > 0) {
                    PJQ.app.session.project.linkERP(erpProject.id, _.bind(function (res) {
                        if (res != null) {
                            this.render();
                        }
                    }, this));
                }
            }, this)
        });
    },
    pushERP: function () {
        if (this.options.project != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_BUDGET)) {
            this.erpButtons?.pushing(true);
            this.erpIntegration.pushBudget(this.budget, _.bind(function () {
                this.erpButtons?.pushing(false);
                PJQ.notifications.notify.successNotify({
                    message: 'Budget pushed to ERP'
                });
                this.render();
            }, this));
        }
    },
    pullERP: function () {
        if (this.options.project != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_BUDGET)) {
            this.erpButtons?.pulling(true);

            this.erpIntegration.pullBudget(this.options.project, (res, err) => {
                this.erpButtons?.pulling(false);

                if (res == null) {
                    return;
                }

                PJQ.notifications.notify.successNotify({
                    message: 'Budget pulled from ERP'
                });

                this.budgetView = null;
                PJQ.app.session.project.fetchCostCodes(_.bind(function (costCodes) {
                    this.costCodes = costCodes;
                    this.options.hasDivisions = this.costCodes.hasDivisions();
                    PJQ.app.session.project.fetchCostTypes(_.bind(function (costTypes) {
                        this.costTypes = costTypes;
                        this.render();
                    }, this), true);
                }, this), true);
            });
        }
    },
    undoPushERP: function () {
        if (this.budget.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.budget, _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Budget removed from ERP approval'
                });
                this.render();
            }, this));
        }
    },
    exportBudget: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'budgets',
                value: this.budget.get('id')
            },
            {
                endpoint: 'export'
            }
        ], [
            {
                parameter: 'viewId',
                value: this.view.id
            }
        ]), {isAPIv2: true});
    },
    searchBudget: function () {
        let searchVal = this.$('.budget-search').val(),
            filteredIds = [];
        if (this.options.hasDivisions) {
            this.dataTable.dataTable.search(searchVal).draw();
        } else {
            _.each(this.childDataTables, function (dt) {
                dt.dataTable.search(searchVal).draw();
                _.each(dt.dataTable.rows({search: 'applied'}).data(), function (row) {
                    filteredIds.push(row.id);
                }, this);
            }, this);

            _.each(this.dataTable.dataTable.rows().data(), function (data, index, dt) {
                let column = this.$('tr#' + (data.id)),
                    isValid = false,
                    row = this.dataTable.getRow(data.id);
                _.each(filteredIds, function (id) {
                    if (_.contains(data.lineItemIds, id)) {
                        isValid = true;
                    }
                }, this)

                if (isValid) {
                    column.show();
                    row.child.show();
                } else {
                    column.hide();
                    row.child.hide()
                }
            }, this)
        }
    },
    unlockBudget: function () {
        // deleteModifications
        this.budget.updateLocked(false, _.bind(function (success) {
            if (success) {
                this.render();
            }
        }, this));
    },
    getColumns: function (level) {
        let isLastLevel = level === _.size(this.options.groupBy),
            columns = [
                {
                    // "data": "",
                    "title": '<i class="fal ' + (_.size(this.expandedItems) > 0 ? 'fa-minus-circle' : 'fa-plus-circle') + ' expand-all-items" style="cursor: pointer"></i>',
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        // budgetId is an attribute that only exists if it's a line item
                        let html = '';
                        if (!isLastLevel) {
                            html = '<i class="fal fa-plus-circle expand-item" data-type="" data-id="' + row.id + '" style="cursor: pointer"></i>';
                        } else if (row.isUnBudgeted) {
                            html = '<i class="fas fs-18 text-warning fa-exclamation-circle" title="Line item was added automatically and has not been budgeted yet."></i> '
                        }

                        return '<div class="wd-15p">' + html + '</div>';
                    }, this)
                }
            ],
            canClickColumnData = _.size(this.options.groupBy) === level;
        columns.push({
            "title": "Budget Code",
            "width": "250px",
            "data": "budgetCode",
            "type": 'num',
            "render": _.bind(function (data, type, row) {
                if (type === 'sort') {
                    let sValue = row.costCode ? row.costCode.get('code') : row.budgetCode,
                        numOnly = PJQ.helpers.formatHelpers.numbersOnly(sValue, false);
                    return _.size(numOnly) > 0 ? parseInt(numOnly) : sValue;
                }

                let classes = '';
                if (!isLastLevel) {
                    classes = 'font-weight-bold';
                }

                let padding = level * 5;
                return '<div class="' + classes + '" style="width:250px;padding-left:' + padding.toString() + 'px;">' + data + '</div>';
            }, this)
        });

        _.each(this.budgetView.columns, function (column, index) {
            columns.push({
                "data": "",
                "title": column.name,
                "orderable": false,
                "render": _.bind(function (data, type, row) {
                    let val = row.columnData[index],
                        extraClasses = '';
                    if (column.format === 'money') {
                        let rawVal = PJQ.helpers.formatHelpers.numbersOnly(val, false, true);
                        // extraClasses += 'wd-80p '
                        if (rawVal < 0) {
                            extraClasses += 'text-danger ';
                        }
                    } else if (column.format === 'decimal' || column.format === 'percent') {
                        if ((column.source === 'TimeCardValues') && Array.isArray(val)) {
                            let totalMinutes = _.reduce(val, function (total, timeValue) {
                                let timeDecimal = Math.floor(timeValue / 100) + (timeValue % 100) / 100;

                                let hours = Math.floor(timeDecimal);
                                let minutes = Math.round((timeDecimal - hours) * 100 * 60 / 100);

                                return total + (hours * 60) + minutes;
                            }, 0);

                            val = totalMinutes / 60;
                        } else if (column.source === 'TimeCardValues') {
                            val = ((val ?? 0) / 100).toFixed(2);
                        } else {
                            val = (val ?? 0).toFixed(2);
                            if (column.format === 'percent') {
                                val = val + '%';
                            }
                        }
                    } else if (column.format === 'time') {
                        val = PJQ.helpers.timecards.getFormattedTime(val);
                    }

                    if (column.source === 'TimeCardValues') {
                        let minutes = PJQ.helpers.dateHelpers.getMinutesFromHoursDecimal(val);
                        val = PJQ.helpers.timecards.getFormattedTime(minutes);
                    }

                    if (canClickColumnData) {
                        let statuses = column.options && column.options.statuses ? column.options.statuses.join(',') : '',
                            result = val;
                        switch (column.source) {
                            case "CommitmentValues":
                                result = '<a href="javascript:void(0)" class="btn-view-commitments" data-statuses="' + statuses + '" data-id="' + row.id + '">' + val.toString() + '</a>'
                                break;
                            case "BudgetedCost":
                                if (this.options.canEdit) {
                                    result = '<a href="javascript:void(0)" class="btn-edit-budget" data-id="' + row.id + '">' + val.toString() + '</a>'
                                } else {
                                    result = val.toString();
                                }
                                break;
                            case "BudgetedHours":
                                if (this.options.canEdit) {
                                    result = '<a href="javascript:void(0)" class="btn-edit-budget" data-id="' + row.id + '">' + val.toString() + '</a>'
                                } else {
                                    result = val.toString();
                                }
                                break;
                            case "ForecastToComplete":
                                result = '<a href="javascript:void(0)" class="btn-edit-forecast" data-id="' + row.id + '">' + val.toString() + '</a>'
                                break;
                            case "BudgetModification":
                                result = '<a href="javascript:void(0)" class="btn-view-modifications" data-id="' + row.id + '">' + val.toString() + '</a>'
                                break;
                            case "PrimeContractValues":
                                result = '<a href="javascript:void(0)" class="btn-view-prime-contracts" data-statuses="' + statuses + '" data-id="' + row.id + '">' + val.toString() + '</a>'
                                break;
                            case "CommitmentChangeOrderValues":
                                result = '<a href="javascript:void(0)" class="btn-view-cco" data-statuses="' + statuses + '" data-id="' + row.id + '">' + val.toString() + '</a>'
                                break;
                            case "PrimeContractChangeOrderValues":
                                result = '<a href="javascript:void(0)" class="btn-view-pcco" data-statuses="' + statuses + '" data-id="' + row.id + '">' + val.toString() + '</a>'
                                break;
                            case "DirectCostValues":
                                result = '<a href="javascript:void(0)" class="btn-view-direct-costs" data-statuses="' + statuses + '" data-id="' + row.id + '">' + val.toString() + '</a>'
                                break;
                            case "PayableInvoiceValues":
                                result = '<a href="javascript:void(0)" class="btn-view-payable-invoices" data-statuses="' + statuses + '" data-id="' + row.id + '">' + val.toString() + '</a>'
                                break;
                            case "ReceivableInvoiceValues":
                                result = '<a href="javascript:void(0)" class="btn-view-receivable-invoices" data-statuses="' + statuses + '" data-id="' + row.id + '">' + val.toString() + '</a>'
                                break;
                        }
                        return '<span class="' + extraClasses + '">' + result + '</span>';
                    } else {
                        return '<span class="font-weight-bold ' + extraClasses + '">' + val + '</span>';
                    }
                }, this)
            })
        }, this)
        return columns;
    },
    createSnapshot: function () {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'budgets',
                    value: this.budget.get('id')
                },
                {
                    endpoint: 'snapshot'
                }
            ]),
            isAPIv2: true,
        }).post().done(_.bind(function (data) {
            data.createdOn = new Date()
            this.snapshots.add(data);
            this.render();
            PJQ.notifications.notify.successNotify({
                message: 'Snapshot successfully created'
            });
        }, this));
    },
    expandChildTables: function (dataTable, level, expand = null) {
        let self = this,
            hasChildren = _.size(this.options.groupBy) >= level;
        if (hasChildren && dataTable && dataTable.dataTable) {
            dataTable.dataTable.rows().every(function () {
                self.renderChildTable(this, dataTable, level, expand != null ? expand : true);
            });
        }
    },
    renderChildTable: function (row, parentTable, level, expand = null) {
        let $tr = $(row.node()),
            $expandIcon = $tr.find('.expand-item'),
            id = row.data().id;
        if (row.child.isShown() || expand === false) {
            // This row is already open - close it
            row.child.hide();
            $tr.removeClass('shown');
            $expandIcon.removeClass('fa-minus-circle').addClass('fa-plus-circle');
        } else {
            $expandIcon.removeClass('fa-plus-circle').addClass('fa-minus-circle');
            let childClass = 'subgrid-' + id.toString(),
                $childTable = $('<div data-id="' + id + '" />', {
                    class: childClass + ' p-2'
                });
            row.child($childTable).show();

            let parent = row.data(),
                childData = this.getDataForLevel(level, parent);
            if (childData != null) {
                this.renderDatatable($childTable, childData, level, parentTable);
            }
        }
    },
    expandAllClicked: function () {
        let $expandIcon = this.$('.expand-all-items');
        if (_.size(this.expandedItems) > 0) {
            this.expandedItems = [];
            $expandIcon.removeClass('fa-minus-circle').addClass('fa-plus-circle');
            this.expandChildTables(this.dataTable, 1, false);
        } else {
            this.expandedItems = [-1];
            $expandIcon.removeClass('fa-plus-circle').addClass('fa-minus-circle');
            this.expandChildTables(this.dataTable, 1, true);
        }
    },
    editLineItemBudgetClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id');
        this.editLineItemBudget(id);
    },
    editLineItemBudget: function (id) {
        let lineItem = this.budget.lineItems.get(id);
        new PJQ.views.budget.EditLineItemBudgetModal({
            model: lineItem,
            budget: this.budget,
            onSave: _.bind(function () {
                lineItem.set('modifiedOn', new Date());
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    addLineItemToBudget: function (lineItem) {
        lineItem.save(null, {
            success: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        })
    },
    editLineItemForecastClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id');
        this.editLineItemForecast(id);
    },
    editLineItemForecast: function (lineItemId) {
        let lineItem = this.budget.lineItems.get(lineItemId);
        new PJQ.views.budget.AddBudgetLineItemForecastModal({
            model: lineItem,
            budget: this.budget,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    viewLineItemReceivableInvoicesClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            statusIds = $target.data('statuses').toString();

        if (_.size(statusIds.trim()) > 0) {
            statusIds = _.map(statusIds.split(','), statusId => parseInt(statusId));
        }

        this.viewLineItemReceivableInvoices(id, statusIds);
    },
    viewLineItemReceivableInvoices: function (lineItemId, statusIds) {
        let lineItem = this.budget.lineItems.get(lineItemId);
        new PJQ.views.invoicing.ModalViewReceivableInvoices({
            model: lineItem,
            budget: this.budget,
            project: this.options.project,
            showAllBillingPeriods: true,
            statusIds: statusIds,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    viewLineItemPayableInvoicesClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            statusIds = $target.data('statuses').toString();

        if (_.size(statusIds.trim()) > 0) {
            statusIds = _.map(statusIds.split(','), statusId => parseInt(statusId));
        }

        this.viewLineItemPayableInvoices(id, statusIds);
    },
    viewLineItemPayableInvoices: function (lineItemId, statusIds) {
        let lineItem = this.budget.lineItems.get(lineItemId);
        new PJQ.views.invoicing.ModalViewPayableInvoices({
            model: lineItem,
            budget: this.budget,
            project: this.options.project,
            showAllBillingPeriods: true,
            statusIds: statusIds,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    viewLineItemPrimeContractsClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            statusIds = $target.data('statuses').toString();

        if (_.size(statusIds.trim()) > 0) {
            statusIds = _.map(statusIds.split(','), statusId => parseInt(statusId));
        }

        this.viewLineItemPrimeContracts(id, statusIds);
    },
    viewLineItemPrimeContracts: function (lineItemId, statusIds) {
        let lineItem = this.budget.lineItems.get(lineItemId);
        new PJQ.views.primeContracts.ModalViewPrimeContracts({
            model: lineItem,
            budget: this.budget,
            project: this.options.project,
            statusIds: statusIds,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    viewLineItemPrimeContractChangeOrdersClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            statusIds = $target.data('statuses').toString();

        if (_.size(statusIds.trim()) > 0) {
            statusIds = _.map(statusIds.split(','), statusId => parseInt(statusId));
        }

        this.viewLineItemPrimeContractChangeOrders(id, statusIds);
    },
    viewLineItemPrimeContractChangeOrders: function (lineItemId, statusIds) {
        let lineItem = this.budget.lineItems.get(lineItemId);
        new PJQ.views.primeContracts.ModalViewChangeOrders({
            model: lineItem,
            budget: this.budget,
            project: this.options.project,
            statusIds: statusIds,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    viewLineItemCommitmentChangeOrdersClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            statusIds = $target.data('statuses').toString();

        if (_.size(statusIds.trim()) > 0) {
            statusIds = _.map(statusIds.split(','), statusId => parseInt(statusId));
        }

        this.viewLineItemCommitmentChangeOrders(id, statusIds);
    },
    viewLineItemCommitmentChangeOrders: function (lineItemId, statusIds) {
        let lineItem = this.budget.lineItems.get(lineItemId);
        new PJQ.views.commitments.ModalViewChangeOrders({
            model: lineItem,
            statusIds: statusIds,
            budget: this.budget,
            project: this.options.project,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    viewLineItemCommitmentsClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            statusIds = $target.data('statuses').toString();

        if (_.size(statusIds.trim()) > 0) {
            statusIds = _.map(statusIds.split(','), statusId => parseInt(statusId));
        }

        this.viewLineItemCommitments(id, statusIds);
    },
    viewLineItemCommitments: function (lineItemId, statusIds) {
        let lineItem = this.budget.lineItems.get(lineItemId);
        new PJQ.views.commitments.ModalViewCommitments({
            model: lineItem,
            budget: this.budget,
            statusIds: statusIds,
            project: this.options.project,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    viewLineItemDirectCostsClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            statusIds = $target.data('statuses').toString();

        if (_.size(statusIds.trim()) > 0) {
            statusIds = _.map(statusIds.split(','), statusId => parseInt(statusId));
        }

        this.viewLineItemDirectCosts(id, statusIds);
    },
    viewLineItemDirectCosts: function (lineItemId, statusIds) {
        let lineItem = this.budget.lineItems.get(lineItemId);
        new PJQ.views.directcosts.ModalViewDirectCosts({
            model: lineItem,
            budget: this.budget,
            project: this.options.project,
            statusIds: statusIds,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    addLineItems: function () {
        new PJQ.views.budget.AddBudgetLineItemsModal({
            budget: this.budget,
            costCodes: this.costCodes,
            onSave: _.bind(function () {
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    filterLineItems: function (lineItemIds, filterText) {
        if (_.size(lineItemIds) > 0 || _.size(filterText) > 0) {
            return _.filter(this.budgetView.lineItems, function (lineItem) {
                let costCode = this.costCodes.get(lineItem.costCodeId);
                return (_.size(lineItemIds) === 0 || lineItemIds.indexOf(lineItem.id) !== -1) &&
                    (_.size(filterText) === 0 || costCode.getDisplayName().indexOf(filterText) !== -1 || costCode.get('division').indexOf(filterText) !== -1);
            }, this)
        }

        return this.budgetView.lineItems;
    },
    deleteLineItem: function (lineItem) {
        lineItem.destroy({
            wait: true,
            notify: false,
            success: _.bind(function () {
                this.budgetView.lineItems = _.filter(this.budgetView.lineItems, function (itm) {
                    return itm.id !== lineItem.id;
                })
                this.render();
            }, this),
            error: function (model, xhr) {
                if (xhr.responseJSON != null && xhr.responseJSON.type === 'delete_line_item_with_costs') {
                    PJQ.notifications.notify.warningNotify({
                        message: 'You can not delete line items with committed or pending costs or contracts'
                    });
                }
            }
        });
    },
    addBudgetModifications: function () {
        new PJQ.views.budget.AddBudgetModificationsModal({
            budget: this.budget,
            onSave: _.bind(function (modifications) {
                _.each(modifications, (modification) => {
                    let fromLine = this.budget.lineItems.get(modification.get('fromLineItemId'));
                    if (fromLine != null) {
                        fromLine.set('modifiedOn', new Date());
                    }

                    let toLine = this.budget.lineItems.get(modification.get('toLineItemId'));
                    if (toLine != null) {
                        toLine.set('modifiedOn', new Date());
                    }
                });
                this.budgetView = null;
                this.render();
            }, this)
        });
    },
    viewLineItemModificationsClicked: function (e) {
        let $target = $(e.currentTarget),
            id = $target.data('id'),
            lineItem = this.budget.lineItems.get(id);
        this.viewLineItemModifications(lineItem);
    },
    viewLineItemModifications: function (lineItem) {
        new PJQ.views.budget.ViewBudgetModificationsModal({
            budget: this.budget,
            lineItem: lineItem
        });
    },
    manageViews: function () {
        let fnUpdateChoices = _.bind(function (views) {
            this.budgetViews = views;
            if (this.viewSelector != null) {
                this.viewSelector.updateChoices(_.map(this.budgetViews.models, function (bv) {
                    return {
                        value: bv.id,
                        name: bv.get('name')
                    }
                }));
            }
        }, this)
        new PJQ.views.budget.BudgetsViewsEditorModal({
            budget: this.budget,
            budgetViews: this.budgetViews,
            onSave: _.bind(function (vw, views) {
                this.budgetViews = views;
                // fnUpdateChoices(views);
                if (vw.id === this.view.id) {
                    this.setActiveView(vw.id);
                    // this.render();
                }
                this.render();
            }, this),
            onDelete: _.bind(function (vw, views) {
                this.budgetViews = views;
                // fnUpdateChoices(views);
                if (vw.id === this.view.id) {
                    this.setActiveView();
                    // this.render();
                }
                this.render();
            }, this)
        });
    }
});
